import { withRouter } from "react-router-dom";
import CivitatisActivityDetail from "./CivitatisActivityDetail";

function EntertainmentDetails() {
	return <CivitatisActivityDetail />;
}

export default withRouter(EntertainmentDetails);
